import { AHQueryHandlerLoading } from "arkh";
import React, { Suspense, useCallback } from "react";
import { WACategoryScreenProps } from "../../WANavigation";
import { useWACategoryNotePreviewsQueryLoader } from "./useWACategoryNotePreviewsQueryLoader";
import { WACategoryNotePreviews } from "./WACategoryNotePreviews";
import { WANotePreviewTemplate } from "./WANotePreviewTemplate";
import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

type Props = WACategoryScreenProps<"WACategoryNote">;

export function WACategoryNoteComponent(props: {
  maxSize: WidgetSizeT;
  unitSize: number;
  onAdd(_: { title: string; template: WANotePreviewTemplate }): void;
  onAddExisiting?(): void;
  DATA_PREFIX?: string;
}) {
  const queryRef = useWACategoryNotePreviewsQueryLoader(props.DATA_PREFIX);

  return queryRef ? (
    <Suspense fallback={<AHQueryHandlerLoading />}>
      <WACategoryNotePreviews
        maxSize={props.maxSize}
        unitSize={props.unitSize}
        queryRef={queryRef}
        onAdd={props.onAdd}
        onAddExisting={props.onAddExisiting}
      />
    </Suspense>
  ) : null;
}

export function WACategoryNote(props: Props) {
  const onAdd = useCallback(
    ({
      title,
      template,
    }: {
      title: string;
      template: WANotePreviewTemplate;
    }) => {
      props.navigation.navigateDeprecated("WidgetAddNote", {
        defaultTeams: props.route.params.defaultTeams,
        position: props.route.params.position,
        storecastId: props.route.params.storecastId,
        unitSize: props.route.params.unitSize,
        maxSize: props.route.params.maxSize,
        title,
        template,
      });
    },
    [
      props.navigation,
      props.route.params.defaultTeams,
      props.route.params.position,
      props.route.params.storecastId,
      props.route.params.unitSize,
      props.route.params.maxSize,
    ]
  );

  const onAddExisiting = useCallback(() => {
    props.navigation.navigateDeprecated("WidgetAddNoteExisting", {
      defaultTeams: props.route.params.defaultTeams,
      position: props.route.params.position,
      storecastId: props.route.params.storecastId,
      unitSize: props.route.params.unitSize,
      maxSize: props.route.params.maxSize,
    });
  }, [
    props.navigation,
    props.route.params.defaultTeams,
    props.route.params.maxSize,
    props.route.params.position,
    props.route.params.storecastId,
    props.route.params.unitSize,
  ]);

  return (
    <WACategoryNoteComponent
      maxSize={props.route.params.maxSize}
      unitSize={props.route.params.unitSize}
      onAdd={onAdd}
      onAddExisiting={onAddExisiting}
    />
  );
}
